import { DocumentType } from '@/types';

export type IBuyerDocumentTypesReducer = DocumentType[] | null;

const initialState: IBuyerDocumentTypesReducer = null;

const documentTypes = (state = initialState, action) => {
    switch (action.type) {
        case 'BUYER_SET_DOCUMENT_TYPES':
            return action.data;
        default:
            return state;
    }
};

export default documentTypes;